import { render } from "./App.vue?vue&type=template&id=6d26eead"
const script = {}
script.render = render

export default script